import { Message,Loading} from 'element-ui'

import $ from 'jquery'
/**
 * post extends vue
 */
let baseUrl = process.env.BASE_API
let request = {
	post(api,param){
		return new Promise((resolve,reject) => {
			$.ajax({
				url : baseUrl + api,
				dataType:'json',//服务器返回json格式数据
				data : param,
				type:'post',//HTTP请求类型
				timeout:10000,//超时时间设置为10秒；
				success:function(data){
					if(data.code == 0){
						resolve(data);
					}
					else{
						Message({
							type : 'error',
							message : data.errMsg
						});
					}
				},
				error:function(xhr){
					reject(xhr);
				}
			});
		})
	},
	get(api){
		return new Promise((resolve,reject) => {
			$.ajax({
				url : baseUrl + api,
				dataType:'json',//服务器返回json格式数据
				type:'get',//HTTP请求类型
				timeout:10000,//超时时间设置为10秒；
				success:function(data){
					if(data.code == 0){
						resolve(data);
					}
					else{
						Message({
							type : 'error',
							message : data.errMsg
						});
						reject(data);
					}
				},
				error:function(xhr){
					console.log('error')
					console.log(xhr)
					reject(xhr);
				}
			});
		});
	}
} 


export default request;


// WEBPACK FOOTER //
// ./src/utils/request.js